 // (async()=>{var e=await import(window.theme.modules.baseComponent);customElements.define("product-recommendations",class extends e.default{render(){fetch(this.dataset.url).then(e=>e.text()).then(e=>{const t=document.createElement("div");t.innerHTML=e;const n=t.querySelector("product-recommendations");n&&n.innerHTML.trim().length&&(this.innerHTML=n.innerHTML)}).catch(e=>{console.error(e)})}})})();

setTimeout(() => {
  (async () => {
    var baseModule = await import(window.theme.modules.baseComponent);

    customElements.define("product-recommendations", class extends baseModule.default {
      render() {
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(html => {
            const wrapper = document.createElement("div");
            wrapper.innerHTML = html;
            const content = wrapper.querySelector("product-recommendations");
            if (content && content.innerHTML.trim().length) {
              this.innerHTML = content.innerHTML;
              this.classList.add('product-recommendations--loaded');
              StampedFn?.reloadUGC?.();

              this.addEventListener("click", (event) => {
                const card = event.target.closest(".custom-product-card");
                if (card && !event.target.closest("button")) {
                  card.querySelector("button")?.click();
                }
              });
              
            } 
            else {
              // Optional: Show fallback message or remove section
              this.innerHTML = ''; // or a fallback message
              this.style.display = 'none'; // Or `this.remove();` if you want to remove from DOM
            }
            
          })
          
          .catch(error => {
            console.error(error);
          });
      }
    });
  })();
}, 500);

